import BookImage from '@assets/images/ai4.png';
import { IStoryList } from '@coreStory/type';
import { useSaveStory, useUnSaveStory } from '@coreStory/useCase';
import { FC, useEffect, useState } from 'react';
import { FaBookmark, FaRegBookmark } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';

const MobileStoryCard: FC<IStoryList> = ({
  StoryImage,
  StoryName,
  StoryText,
  IsSaved,
  StoryID,
}) => {
  const { mutate: saveStory } = useSaveStory();
  const { mutate: unSaveStory } = useUnSaveStory();
  const [isStorySaved, setIsStorySaved] = useState<boolean>();
  const handleSaveStory = () => {
    StoryID && saveStory(String(StoryID));
    setIsStorySaved(true);
  };
  const handleUnSaveStory = () => {
    StoryID && unSaveStory(String(StoryID));
    setIsStorySaved(false);
  };
  useEffect(() => {
    if (IsSaved) {
      setIsStorySaved(true);
    } else {
      setIsStorySaved(false);
    }
  }, [IsSaved]);

  return (
    <div className={styles['card']}>
      <Link to={`/story/${StoryID}`} className={styles['img']}>
        {StoryImage ? (
          <img src={`http://${StoryImage}`} alt={StoryName} />
        ) : (
          <img src={BookImage} alt={StoryName} />
        )}
      </Link>
      <div className={styles['desc']}>
        <div className={styles['title']}>
          <Link to={`/story/${StoryID}`}>
            <h2>{StoryName}</h2>
          </Link>
          <span className={styles['icon']}>
            {isStorySaved ? (
              <FaBookmark size={16} onClick={handleUnSaveStory} />
            ) : (
              <FaRegBookmark size={16} onClick={handleSaveStory} />
            )}
          </span>
        </div>
        <Link to={`/story/${StoryID}`}>
          {' '}
          <p>{StoryText}</p>
        </Link>
      </div>
    </div>
  );
};

export default MobileStoryCard;
